import React, { useEffect, useCallback } from "react";
import { IonRouterOutlet } from "@ionic/react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "./data/connect";
import { useAuth0 } from "@auth0/auth0-react";
import {
  setUserId,
  setUserProperties,
} from "firebase/analytics";
import { analytics } from "./index";

import Projects from "./pages/Projects/Projects";
import Workforce from "./pages/Workforce/Workforce";
import WmbeSlbe from "./pages/WmbeSlbe/WmbeSlbe";
import Contact from "./pages/Contact";
import Alerts from "./pages/Alerts/Alerts";
import Home from "./pages/Home";
import Menu from "./components/Navigation/Menu";
import Loading from "./components/Loading/Loading";
import Seo from "./components/Seo";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

const Appp = ({ loading }) => {
  // Style the Google Translate menu frame and add accessibility attributes
  const applyGoogleTranslateStyles = useCallback(() => {
    // Add aria-label to the Google Translate select element
    const translateSelect = document.querySelector(".goog-te-combo");
    if (translateSelect) {
      translateSelect.setAttribute("aria-label", "Select language for translation");
      translateSelect.setAttribute("title", "Select language for translation");
    }

    const menuFrame = document.querySelector(".goog-te-menu-frame");
    if (menuFrame && menuFrame.contentDocument) {
      const menu = menuFrame.contentDocument.querySelector(".goog-te-menu2");
      if (menu) {
        menu.style.maxWidth = "100%";
        menu.style.overflowX = "auto";
        menu.style.boxSizing = "border-box";
        menu.style.height = "auto";
        return true;
      }
    }
    return translateSelect !== null;
  }, []);

  const googleTranslateElementInit = useCallback(() => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
      },
      "google_translate_element"
    );

    // Retry styling until the frame is ready (max 50 attempts = 2.5s)
    let attempts = 0;
    const maxAttempts = 50;
    const styleInterval = setInterval(() => {
      attempts++;
      if (applyGoogleTranslateStyles() || attempts >= maxAttempts) {
        clearInterval(styleInterval);
      }
    }, 50);
  }, [applyGoogleTranslateStyles]);

  useEffect(() => {
    const addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    );
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;

    return () => {
      // Cleanup: remove script on unmount
      if (addScript.parentNode) {
        addScript.parentNode.removeChild(addScript);
      }
    };
  }, [googleTranslateElementInit]);

  const { isLoading, user, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (isAuthenticated && user) {
      setUserId(analytics, user.sub);
      setUserProperties(analytics, { account_id: user.sub });
    }
  }, [isAuthenticated, user]);

  if (isLoading || loading) {
    return <Loading />;
  }

  return (
    <>
      <a href="#main" className="skip-link">
        Skip to main content
      </a>
      <Seo />
      <Menu />
      <IonRouterOutlet id="main">
        <Route path="/" render={() => <Home />} exact />
        <Route path="/projects" render={() => <Projects />} />
        <Route path="/alerts" render={() => <Alerts />} exact />
        <Route path="/contact" render={() => <Contact />} exact />
        <Route exact path="/workforce" render={() => <Workforce />} />
        <Route exact path="/wmbe-slbe" render={() => <WmbeSlbe />} />
        <Route exact path="/privacy-policy" render={() => <PrivacyPolicy />} />
        <Route
          exact
          path="/terms-and-conditions"
          render={() => <TermsConditions />}
        />
        <Route exact path="/home" render={() => <Redirect to="/" />} />
      </IonRouterOutlet>
      <div
        id="google_translate_element"
        role="region"
        aria-label="Language translation"
      ></div>
    </>
  );
};

export default connect({
  mapStateToProps: (state) => ({
    loading: state.data.loading,
  }),
  component: React.memo(Appp),
});
